import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import { useAuth } from "../context/AuthContext";

const DISMISS_KEY = "tj_paywall_banner_dismissed_session";

export default function PaywallBanner() {
  const { user, organization } = useAuth();
  const { t } = useTranslation();
  if (!user || user.role !== "agency") return null;
  if (!organization) return null;
  if (organization.status !== "active") return null;
  const dismissed = sessionStorage.getItem(DISMISS_KEY) === "1";
  const sub = organization.subscription_status || "none";
  if (sub === "active" || sub === "trialing") return null;
  if (dismissed) return null;

  return (
    <div
      className="border-b border-amber-200 bg-amber-50 px-6 py-2.5 text-sm text-amber-900"
      data-testid="paywall-banner"
    >
      <div className="mx-auto flex max-w-6xl items-center justify-between gap-4">
        <p className="flex items-center gap-2">
          <span className="text-base">🔒</span>
          <span className="font-medium">{t("paywall.banner_title")}</span>
          <span className="hidden sm:inline text-amber-800">— {t("paywall.banner_body")}</span>
        </p>
        <div className="flex items-center gap-3">
          <Link
            to="/settings/subscription"
            className="rounded-lg bg-amber-900 px-3 py-1.5 text-xs font-semibold text-amber-50 hover:bg-amber-800"
            data-testid="paywall-banner-cta"
          >
            {t("paywall.banner_cta")}
          </Link>
          <button
            className="text-xs font-medium text-amber-700 hover:text-amber-900"
            onClick={() => {
              sessionStorage.setItem(DISMISS_KEY, "1");
              window.location.reload();
            }}
            data-testid="paywall-banner-dismiss"
          >
            {t("common.dismiss")}
          </button>
        </div>
      </div>
    </div>
  );
}
